/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Button from '@material-ui/core/Button';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {
  t: TranslatorProps,
  actionDrawerStore: TypeActionDrawerStore,
  response: Object,
};

@translate()
@inject('actionDrawerStore')
@observer
export default class RequestAssetQuoteSuccess extends React.Component<*> {
  render(): React.Fragment {
    const { t, actionDrawerStore, response }: TypeProps = this.props;

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <div className={styles['success-details']}>
            <h3>{t('general:assets.messages.quote_request_sent')}</h3>
            <p>{t('general:assets.messages.quote_request_thanks')}</p>
            <p>{t('general:assets.messages.quote_request_receipt')}</p>
            <ul>
              <li>
                <b>{t('general:labels.quote_for')}:</b>
              </li>
              <li>{`${response.manufacturer}, ${response.model}`}</li>
            </ul>
            <ul>
              <li>
                <b>{t('general:labels.interested_in')}:</b>
              </li>
              {response.request_type.indexOf('rental') > -1 && (
                <li>{t('general:assets.renting')}</li>
              )}
              {response.request_type.indexOf('new') > -1 && (
                <li>{t('general:assets.buying_new')}</li>
              )}
              {response.request_type.indexOf('used') > -1 && (
                <li>{t('general:assets.buying_used')}</li>
              )}
            </ul>
            {response.quote_message && (
              <ul>
                <li>
                  <b>{t('general:message')}:</b>
                </li>
                <li>{response.quote_message}</li>
              </ul>
            )}
          </div>
        </div>
        <div className={styles['action-drawer-actions']}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => actionDrawerStore.closeActionDrawer()}
          >
            {t('general:actions.close')}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}
